import {defineMessages} from 'react-intl';

export const surveyResponseMessages = defineMessages({
  comments: {
    id: 'surveyResponseMessages.comments',
    defaultMessage: 'Comments',
  },
});
